module.exports = __webpack_public_path__ + "static/media/newsletter-august-2021-pilgrimage.1cd74605.jpg";